import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as tagActions from '../actions';
import { Button } from '@myua/kit';
import { getSelectedIds, getTagsComposition } from '../selectors';

export const ResetButton: React.FC = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedIds);
  const items = useSelector(getTagsComposition);

  return (
    <Button
      onClick={() => {
        if (selectedIds.length > 0) {
          dispatch(tagActions.tagsSelected({ ids: [], saveLastState: true, log: { tags: [] } }));
        }
      }}
      className={`al-tag-item ${
        items.some(({ selected }) => selected) ? '' : 'al-tag-item_checked'
      }`}
      title="Clear all tags"
    >
      All assets
    </Button>
  );
};
